/* eslint-disable jsx-a11y/anchor-is-valid */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { injectIntl } from 'react-intl';
import { emptyPoint, emptyPointUpdate } from '../../api/CollectionpointOperators';
import { ICollectionPoint, ICollectionPointOperator, ICollectionPointUpdate } from '../../util/DataModelInterface';
import CollectionPoint, { cPointPages } from './CollectionPoint';
import Operator from './Operator';

interface IOperatorListProps {
  intl: any;
  operators: ICollectionPointOperator[];
  points: ICollectionPoint[];
  stores: boolean;
  searching: boolean;
  update: () => void;
  showModal: () => void;
  onError: (msg: string) => void;
}

interface IOperatorListState {
  activePage: string;
  point: ICollectionPoint;
  operatorId: string;
  addedPoint: ICollectionPointUpdate;
  updatedPoint: ICollectionPointUpdate;
  addView: boolean;
}

class OperatorList extends React.Component<IOperatorListProps, IOperatorListState> {
  constructor(props: any) {
    super(props);
    this.state = {
      activePage: cPointPages.none,
      point: emptyPoint(),
      operatorId: '',
      addedPoint: emptyPointUpdate(),
      updatedPoint: emptyPointUpdate(),
      addView: false
    }
  }

  shouldComponentUpdate(newProps: IOperatorListProps, newState: IOperatorListState) {
    // Rendering the component only if 
    // passed props value is changed
    if (newProps.operators !== this.props.operators ||
        newProps.operators.length !== this.props.operators.length ||
        newProps.points.length !== this.props.points.length ||
        newProps.stores !== this.props.stores ||
        newProps.searching !== this.props.searching ||
        newState !== this.state) {
      return true;
    } else {
      return false;
    }
  }

  getOperatorCardList = () => {
    const cards: { }[] = [];
    const data = this.props.operators;
    if (data.length > 0) {
      data.forEach((row : ICollectionPointOperator) => {
        cards.push(
          <Operator operator={row} key={row.id}
                    addPoint={row.id === this.state.operatorId ? this.state.addedPoint : emptyPointUpdate(row.reportformat==='STORE')}
                    updatePoint={row.id === this.state.operatorId ? this.state.updatedPoint : emptyPointUpdate(row.reportformat==='STORE')}
                    editPoint={ (p: ICollectionPoint) => { this.editCollectionPoint(p, row.id); }}
                    update={ () : void => { this.updateData(); }}
                    modal={ () : void => { this.props.showModal(); } }
                    error={ (msg) : void => { this.props.onError(msg); } }
                    addNew={false}
                    close={ () : void => { this.closeView(); }}
                    pointAdded={ () : void => { this.setState({addedPoint: emptyPointUpdate()} ); }}
                  />
        );
      });
      return cards;
    }
    if(this.props.searching)
      return (<div className="waitSpinner">{this.props.intl.formatMessage({id: 'settings.operators.nodata'})}</div>);
    else return (<div className="waitSpinner"><div className="spinner"/></div>);
  }

  editCollectionPoint = (p: ICollectionPoint, id: string) => {
    this.setState({operatorId: id, 
                   point: p, 
                   activePage: p.info.collectionpoint_id !== "" ? cPointPages.edit : cPointPages.add});
  }

  updateData = () => {
    this.props.update();
    this.setState({ addedPoint: emptyPointUpdate() });
  }

  closeView = () => {
    this.setState({ addView: false, 
                    addedPoint: emptyPointUpdate(),
                    activePage: cPointPages.none,
                    point: emptyPoint()});
  }

  closePointView = (addView: boolean) => {
    this.setState({ addView: addView,
                    activePage: cPointPages.none } );
  }

  render() {
    return (
      <div>
        {!this.state.addView && // Add new operator button
        <div className="d-flex flex-md-row flex-column mb-4">
          <button className={!this.state.addView ? "btn btn-link ml-md-auto list-button" : "hidden"} 
                  onClick={() => this.setState({addView: !this.state.addView})}>
            <FontAwesomeIcon className="LeftIcon" icon={ "plus-circle" } color="var(--serty-green)"/>
            { this.props.intl.formatMessage({id: this.props.stores ? 'settings.operators.addstore' : 'settings.operators.addoperator'}) }
          </button>
        </div>}
        {this.state.addView && // Add new operator
          <Operator operator={{ id: "", name: "", 
                                collection_points: [] as ICollectionPoint[], 
                                autoemail: false, reportformat: this.props.stores ? 'STORE' : '', emails: [] as string[] 
                              } as ICollectionPointOperator}
                    key={""} addNew={true}
                    addPoint={this.state.addedPoint}
                    updatePoint={emptyPointUpdate()}
                    editPoint={ (p: ICollectionPoint) => { this.editCollectionPoint(p, "") }}
                    update={ () : void => { this.updateData(); }}
                    modal={ () : void => { this.props.showModal(); }}
                    error={ (msg) : void => { this.props.onError(msg); }}
                    close={ () : void => { this.closeView(); }} 
                    pointAdded={ () : void => { this.setState({addedPoint: emptyPointUpdate()} ); }}
            />}
        <div className="accordion">
          { this.getOperatorCardList() }
        </div>
        {(this.state.activePage !== cPointPages.none) &&
          <div>
            <CollectionPoint
              key={this.state.point.info.collectionpoint_id}
              type={this.state.activePage}
              points={this.props.points}
              operatorId={this.state.operatorId}
              point={this.state.point}
              update={(p: ICollectionPointUpdate) : void => { this.updateData(); this.setState({updatedPoint: p}); }}
              modal={() : void => { this.props.showModal(); }}
              error={(msg) : void => { this.props.onError(msg); }}
              close={() => { this.closePointView(this.state.addView); }}
              add={(point: ICollectionPointUpdate) => { if(point.info.name !== "") this.setState({addedPoint: point}); }}
            />
        </div>}
      </div>
    );
  }
}

export default injectIntl(OperatorList);
